import type { RouterConfig } from '@nuxt/schema';

export default {
  linkActiveClass: '',
  linkExactActiveClass: '',
  scrollBehavior(to, _from, savedPosition) {

    if (savedPosition) {

      return savedPosition;

    }

    if (to.hash) {

      return new Promise((resolve) => {

        if (!import.meta.client) {

          return resolve({ left: 0, top: 0 });

        }

        const scrollTarget = { el: to.hash, left: 0, top: 0 };

        if (document.querySelector(to.hash)) {

          return resolve(scrollTarget);

        }

        const ANCHOR_SCROLL_TIMEOUT_MS = 2000;
        const ANCHOR_SCROLL_CHECK_INTERVAL_MS = 100;
        let elapsed = 0;

        const interval = setInterval(() => {

          elapsed += ANCHOR_SCROLL_CHECK_INTERVAL_MS;

          if (document.querySelector(to.hash) || elapsed >= ANCHOR_SCROLL_TIMEOUT_MS) {

            clearInterval(interval);
            resolve(scrollTarget);

          }

        }, ANCHOR_SCROLL_CHECK_INTERVAL_MS);

      });

    }

    return { left: 0, top: 0 };

  },
} satisfies RouterConfig;
